<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-input v-model="form.printerId" hidden/>


      <t-input v-model="form.typePrinterId"
               :options="groupTypePrinterOptions"
               label="Modelo de Impressora" required select
               help="Somente modelos homologados estão disponíveis, caso desejar outros modelos será necessário homologação a parte de outros fabricantes e modelos."/>

      <t-input v-model="form.name"  :add-error="error.name" label="Nome" required/>

      <t-input v-model="form.path" label="Caminho de Instalação"
               help="Caminho de Rede da instalação com nome da impressora instalada" required/>


      <t-input v-model="form.defaultTag" label="Tag de Impressora Preferencial" help="Utilizado em locais onde não se deseja utilizar a impressora padrão geral. Por exemplo: Expedições possui uma impressora, por tanto a tag é 'expedition'"/>

      <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

      <t-form-card unshaded title="Configurações">
        <b-form-checkbox v-model="form.printerDefault" switch>
          Impressora padrão?
          <t-help
              title="Marque caso desejar tornar esta impressora padrão."/>
        </b-form-checkbox>

        <b-form-checkbox v-model="form.printerAllCompanies" switch>
          Habilitar impressão para todas as empresas relacionadas?
          <t-help
              title="Desmarque esta opção, somente se desejar especificar que esta impressora esteja disponível para uma determinada empresa."/>
        </b-form-checkbox>

        <t-input v-if="!form.printerAllCompanies" v-model="form.companyId" :add-error="error.companyId"
                 placeholder="Especifique uma empresa"
                 :options="companyOptions" required label="Empresa" hide-label select/>

        <t-input class="mt-3" v-if="command !== 'insert'" textarea fixed label="Token para Instalação" v-model="form.token"></t-input>

      </t-form-card>




      <t-input-status v-model="form.status"/>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import companyService from "@/services/modules/admin/Company.service";
import typePrinterService from "@/services/modules/general/TypePrinter.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'PrinterForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "printerId",
      form: {
        printerId: 0,
        typePrinterId: 0,
        companyId: 0,
        printerDefault: false,
        printerAllCompanies: true,
        name: "",
        path: "",
        defaultTag: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        companyId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      groupTypePrinterOptions: [],
      companyOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      await typePrinterService.selectList("grouped").then((list) => {
        this.groupTypePrinterOptions = list
      }).catch(error => this.responseError(error))


      await companyService.selectList("").then((list) => {
        this.companyOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
